import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";
import { headerPost } from "@/config"

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, password) {
	return client.post('member/login', qs.stringify({ username, password }), headerPost, true);
}

export default {
	login,
};